import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { COUNTRY_CODE } from "../../../utils/country-code";

interface PhoneNumberSectionProps {
  phoneNumber?: string;
  callingCode?: string;
  error?: string;
  onChangePhone: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeCallingCode: (value: string) => void;
  varies?: "MYPAGE/BILLING"[];
}

const PhoneNumberSection: React.FC<PhoneNumberSectionProps> = ({
  phoneNumber,
  callingCode,
  error,
  onChangePhone,
  onChangeCallingCode,
  varies,
}) => {
  const handleNumericInput = (e: React.FormEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    // Allow only numeric input
    input.value = input.value.replace(/[^0-9]/g, "");
    onChangePhone(e as React.ChangeEvent<HTMLInputElement>); // Pass event to onChangePhone
  };
  const { t } = useTranslation();
  return (
    <div
      className={clsx("flex flex-col", {
        "gap-[0.625rem]": !varies?.includes("MYPAGE/BILLING"),
        "gap-2": varies?.includes("MYPAGE/BILLING"),
      })}
    >
      <p className="text-[#232323]">{t("Phone number")}</p>
      <div className={clsx("mt-1 flex items-center gap-[0.5rem]")}>
        {/* <Dropdown
          onChange={onChangeCallingCode}
          props={{
            section: {
              style: {
                height: "3.125rem",
                width: "11.25rem",
                borderRadius: "0.625rem",
              },
            },
          }}
          options={COUNTRY_CODE.map((item) => {
            return {
              label: item.countryName + " (" + item.countryCode + ")",
              value: item.countryCode,
              displayLabel: item.countryCode,
            };
          })}
          value={callingCode}
        /> */}
        <div className="callingCode relative" data-code={callingCode}>
          <select
            value={callingCode}
            name="callingCode"
            onChange={(e) => onChangeCallingCode(e.target.value)}
            className="bg-white-a700 text-gray-900x mb-0 h-full w-[7.5rem] select-none rounded-[0.625rem] border border-solid border-gray-300 p-3 text-white focus:border-[#DCDCDC] focus:outline-none"
          >
            {COUNTRY_CODE.map((code) => (
              <option
                className="text-gray-900"
                key={code.countryCode + code.countryName}
                value={code.countryCode}
              >
                {`${code.countryName} (${code.countryCode})`}
              </option>
            ))}
          </select>
        </div>
        <input
          value={phoneNumber}
          onInput={handleNumericInput} // Restrict input to numbers only
          type="text"
          className={clsx(
            "w-full rounded-[0.625rem] border border-gray-300 shadow-sm focus:border-[#DCDCDC] focus:outline-none",
            varies?.includes("MYPAGE/BILLING")
              ? "h-[3.125rem] p-3"
              : "h-[3.125rem] px-4 py-2",
          )}
        />
      </div>
      {error && (
        <div className="mt-2 text-[0.75rem] text-[#DA3838]">{error}</div>
      )}
    </div>
  );
};

export default PhoneNumberSection;
